import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState, AppThunk } from '..';
import { AdminFilters } from '../../components/AdminFiltersControl';
import { ProgramDataDownload } from '../../generated-api';
import LimberAdminApi from '../../api/LimberAdminApi';

export interface ProgramDataError {
}

export interface ProgramDataState {
  loading: boolean;
  error: ProgramDataError | null;
  filters: AdminFilters;
  download: ProgramDataDownload | null;
}

const initialState: ProgramDataState = {
  loading: false,
  error: null,
  filters: {},
  download: null,
};

export const programDataSlice = createSlice({
  name: 'programData',
  initialState,
  reducers: {
    startLoading: (state) => { state.loading = true; },
    loadingFailed: (state, action: PayloadAction<ProgramDataError>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearError: (state) => { state.error = null; },

    setFilters: (state, action: PayloadAction<AdminFilters>) => {
      state.filters = action.payload;
    },

    loadProgramDataSucceeded: (
      state, action: PayloadAction<ProgramDataDownload>,
    ) => {
      state.loading = false;
      state.error = null;
      state.download = action.payload;
    },
    clearDownload: (state) => { state.download = null; },
  },
});

const {
  startLoading, loadingFailed, loadProgramDataSucceeded,
} = programDataSlice.actions;
export const {
  clearError, setFilters, clearDownload,
} = programDataSlice.actions;

export const loadProgramData = (
  getAccessToken: () => Promise<string>,
): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(startLoading());
    const accessToken = await getAccessToken();
    const api = new LimberAdminApi({ accessToken });
    const { filters } = getState().programData;
    const programDataDownload = await api.programDataGet(filters);
    dispatch(loadProgramDataSucceeded(programDataDownload));
  } catch (error) {
    console.error(error);
    dispatch(loadingFailed({
    }));
  }
};

export const selectProgramData = (state: RootState) => state.programData;

export default programDataSlice.reducer;
